import { createSelector } from 'reselect';
import { compact } from 'lodash';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getUserAddress = state => localState(state).address;
export const getFormattedAddress = createSelector(getUserAddress, address => compact([address === null || address === void 0 ? void 0 : address.line1, address === null || address === void 0 ? void 0 : address.line2, address === null || address === void 0 ? void 0 : address.city, address === null || address === void 0 ? void 0 : address.state, address === null || address === void 0 ? void 0 : address.postalCode]).join(' '));
export const getUiState = createSelector(localState, _ref => {
  let {
    ui
  } = _ref;
  return ui;
});
export const getUserAddressUiState = createSelector(getUiState, ui => ui.uiState);
export const getUserAddressUiError = createSelector(getUiState, ui => ui.error);
export const getIsShippingAddressSelected = createSelector(getUiState, ui => ui.isShippingAddressSelected);